// bundle-cart.js

var QTY_DEBOUNCE = 500;
var qtyTimers = {};

// ── バンドル配下の全ラインを指定数量に更新 ──────────────
async function updateBundleQuantity(bundleId, quantity) {
  var cartRes = await fetch('/cart.js');
  if (!cartRes.ok) throw new Error('カート情報の取得に失敗しました');
  var cart = await cartRes.json();

  var updates = {};
  cart.items.forEach(function (item) {
    if (item.properties && item.properties._bundle_id === bundleId) {
      updates[item.key] = quantity;
    }
  });

  if (Object.keys(updates).length === 0) {
    throw new Error('対象の商品が見つかりませんでした');
  }

  var res = await fetch('/cart/update.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ updates: updates })
  });

  if (!res.ok) {
    var errData = await res.json().catch(function () { return {}; });
    throw new Error(errData.description || 'カートの更新に失敗しました');
  }
}

// ── 削除 ──────────────────────────────────────────────
document.addEventListener('click', async function (e) {
  var trigger = e.target.closest('cart-remove-button button, cart-remove-button a');
  if (!trigger) return;

  var removeBtn = trigger.closest('cart-remove-button');
  var bundleId  = removeBtn ? removeBtn.dataset.bundleId : null;
  if (!bundleId) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  trigger.style.opacity       = '0.5';
  trigger.style.pointerEvents = 'none';

  try {
    await updateBundleQuantity(bundleId, 0);
    window.location.reload();
  } catch (err) {
    alert(err.message || '削除中にエラーが発生しました');
    trigger.style.opacity       = '';
    trigger.style.pointerEvents = '';
  }
}, true);

// ── 数量変更の送信をスケジュール ───────────────────────
function scheduleBundleQuantity(wrap, bundleId, quantity) {
  clearTimeout(qtyTimers[bundleId]);
  wrap.classList.add('is-pending');

  qtyTimers[bundleId] = setTimeout(async function () {
    try {
      await updateBundleQuantity(bundleId, quantity);
    } catch (err) {
      alert(err.message || '数量の変更に失敗しました');
    }
    window.location.reload();
  }, QTY_DEBOUNCE);
}

// ── ＋／− ボタン ──────────────────────────────────────
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.cart-bundle__qty-button');
  if (!btn) return;

  var wrap     = btn.closest('.cart-bundle__qty');
  var input    = wrap ? wrap.querySelector('.cart-bundle__qty-input') : null;
  var bundleId = wrap ? wrap.dataset.bundleId : null;
  if (!input || !bundleId) return;

  var current = parseInt(input.value, 10);
  if (isNaN(current) || current < 1) current = 1;

  var next = btn.name === 'plus' ? current + 1 : current - 1;
  if (next < 1) return;

  input.value = next;
  scheduleBundleQuantity(wrap, bundleId, next);
});

// ── 直接入力 ──────────────────────────────────────────
document.addEventListener('change', function (e) {
  var input = e.target.closest('.cart-bundle__qty-input');
  if (!input) return;

  e.stopPropagation();

  var wrap     = input.closest('.cart-bundle__qty');
  var bundleId = wrap ? wrap.dataset.bundleId : null;
  if (!bundleId) return;

  var value = parseInt(input.value, 10);
  if (isNaN(value) || value < 1) value = 1;

  input.value = value;
  scheduleBundleQuantity(wrap, bundleId, value);
});